var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',[_c('h1',[_vm._v("Página Inicial")]),_c('Padrao',{on:{"ler-campos":_vm.lerCampos}}),_c('p',[_vm._v("Valor do campo 1: "+_vm._s(_vm.valorCampo1))]),_c('p',[_vm._v("Valor do campo 2: "+_vm._s(_vm.valorCampo2))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }